export const COPY = {
  CHECK_SPELLING: 'Check your spelling and try again.',
  CHECK_ID_TRY_AGAIN: 'Check whether you have entered the exact patient ID and try again.',
  NEW_MOSAIQ_PATIENT_WAIT: 'Just created a new patient in the EMR? Please wait one minute and refresh the page.',
  NAME_OR_ID: "Try using the patient's first name and last name or patient ID.",
  NO_RESULTS_MATCHING: "Sorry, we couldn't find any results matching",
  SEARCH_TIPS: 'SEARCH TIPS',
  EMPTY_RECENT_PAT_LIST: 'You have not viewed any patient charts recently.',
};
